import axios from 'axios'
import { UrlApi } from '../Keys'
import { toast } from 'react-toastify';
import moment from 'moment';


const dataInicial = {
    divisonesAgestionar: [],
    loadingDaG: false,
    divisionesGestionadas: [],
    loadingDg: false,
    actAgestionar: [],
    loadingActAg: false,
    actGestionadas: [],
    loadingActG: false,
    planificacionesNo: [],
    loadingPlanificacionesNo: false,
    planificaciones: [],
    loadingPlanificaciones: false,
    division: [],
    loadingDivision: false,
    getDivision: null,
    fechas: [],
    loadingFechas: false,
    getFechas: null,
    fechasParciales: [],
    loadingFechasParciales: false,
    getFechasParciales: null,
    horarios: [],
    loadingHorarios: false,
    getHorarios: null,
    formacionDocente: [],
    loadingFormacionDocente: false,
    getFormacion: null,
    loadingTareas: false,
    tareas: [],
    loadingActualizacion: false,
    getTareas: null,
    teamTeaching: [],
    loadingTeamTeaching: false,
    experiencia: [],
    loadingExperiencia: false,
    proyecto: [],
    loadingProyecto: false,
    getProyectoInvestigacion: null,
    transferencia: [],
    loadingTransferencia: false,
    pat: [],
    loadingPAT: false,
    getPat: null,
    pic: [],
    loadingPIC: false,
    getPic: null,
    modificacion: '',
    modificacionPlanificacion: ''
}

const LOADING_A_GESTIONAR = 'LOADING_A_GESTIONAR'
const DIVISIONES_A_GESTIONAR = 'DIVISIONES_A_GESTIONAR'
const DIVISIONES_A_GESTIONAR_ERROR = 'DIVISIONES_A_GESTIONAR_ERROR'

const LOADING_GESTIONADAS = 'LOADING_GESTIONADAS'
const DIVISIONES_GESTIONADAS = 'DIVISIONES_GESTIONADAS'
const DIVISIONES_GESTIONADAS_ERROR = 'DIVISIONES_GESTIONADAS_ERROR'

const LOADING_ACT_A_GESTIONAR = 'LOADING_ACT_A_GESTIONAR'
const ACT_A_GESTIONAR = 'ACT_A_GESTIONAR'
const ACT_A_GESTIONAR_ERROR = 'ACT_A_GESTIONAR_ERROR'

const LOADING_ACT_GESTIONADAS = 'LOADING_ACT_GESTIONADAS'
const ACT_GESTIONADAS = 'ACT_GESTIONADAS'
const ACT_GESTIONADAS_ERROR = 'ACT_GESTIONADAS_ERROR'

const LOADING_PLANIFICACIONESNO = 'LOADING_PLANIFICACIONESNO'
const PLANIFICACIONES_NO = 'PLANIFICACIONES_NO'
const PLANIFICACIONES_NO_ERROR = 'PLANIFICACIONES_NO_ERROR'

const LOADING_PLANIFICACIONES = 'LOADING_PLANIFICACIONES'
const PLANIFICACIONES = 'PLANIFICACIONES'
const PLANIFICACIONES_ERROR = 'PLANIFICACIONES_ERROR'

const LOADING_DIVISION = 'LOADING_DIVISION'
const DIVISION = 'DIVISION'
const DIVISION_ERROR = 'DIVISION_ERROR'

const LOADING_FECHAS_X_DIVISION = 'LOADING_FECHAS_X_DIVISION'
const FECHAS_X_DIVISION = 'FECHAS_X_DIVISION'
const FECHAS_X_DIVISION_ERROR = 'FECHAS_X_DIVISION_ERROR'

const LOADING_FECHAS_PARCIALES = 'LOADING_FECHAS_PARCIALES'
const FECHAS_PARCIALES = 'FECHAS_PARCIALES'
const FECHAS_PARCIALES_ERROR = 'FECHAS_PARCIALES_ERROR'

const LOADING_HORARIOS_X_ASIGNACION = 'LOADING_HORARIOS_X_ASIGNACION'
const HORARIOS_X_ASIGNACION = 'HORARIOS_X_ASIGNACION'
const HORARIOS_X_ASIGNACION_ERROR = 'HORARIOS_X_ASIGNACION_ERROR'

const LOADING_FORMACION_DOCENTE = 'LOADING_FORMACION_DOCENTE'
const FORMACION_DOCENTE = 'FORMACION_DOCENTE'
const FORMACION_DOCENTE_ERROR = 'FORMACION_DOCENTE_ERROR'

const LOADING_ACTUALIZACION = 'LOADING_ACTUALIZACION'
const ACTUALIZACION_EXITO = 'ACTUALIZACION_EXITO'
const ACTUALIZACION_ERROR = 'ACTUALIZACION_ERROR'

const LOADING_TAREAS = 'LOADING_TAREAS'
const TAREAS = 'TAREAS'
const TAREAS_ERROR = 'TAREAS_ERROR'

const LOADING_TEAM_TEACHING = 'LOADING_TEAM_TEACHING'
const TEAM_TEACHING = 'TEAM_TEACHING'
const TEAM_TEACHING_ERROR = 'TEAM_TEACHING_ERROR'

const LOADING_EXPERIENCIA = 'LOADING_EXPERIENCIA'
const EXPERIENCIA = 'EXPERIENCIA'
const EXPERIENCIA_ERROR = 'EXPERIENCIA_ERROR'

const LOADING_PROYECTO = 'LOADING_PROYECTO'
const PROYECTO = 'PROYECTO'
const PROYECTO_ERROR = 'PROYECTO_ERROR'

const LOADING_TRANSFERENCIA = 'LOADING_TRANSFERENCIA'
const TRANSFERENCIA = 'TRANSFERENCIA'
const TRANSFERENCIA_ERROR = 'TRANSFERENCIA_ERROR'

const LOADING_PAT = 'LOADING_PAT'
const PAT = 'PAT'
const PAT_ERROR = 'PAT_ERROR'

const LOADING_PIC = 'LOADING_PIC'
const PIC = 'PIC'
const PIC_ERROR = 'PIC_ERROR'

const MODIFICAR_PLANIFICACION_EXITO = 'MODIFICAR_PLANIFICACION_EXITO'
const MODIFICAR_PLANIFICACION_ERROR = 'MODIFICAR_PLANIFICACION_ERROR'

const LIMPIAR_ESTADOS = 'LIMPIAR_ESTADOS'

//Reducers
export default function asignacionesReducer(state = dataInicial, action) {
    switch (action.type) {
        case MODIFICAR_PLANIFICACION_EXITO:
            return { ...state, modificacionPlanificacion: action.modificacionPlanificacion }
        case MODIFICAR_PLANIFICACION_ERROR:
            return { ...state, modificacionPlanificacion: action.modificacionPlanificacion }
        case ACTUALIZACION_EXITO:
            return { ...state, modificacion: action.modificacion }
        case DIVISIONES_A_GESTIONAR:
            return { ...state, divisonesAgestionar: action.payload, loadingDaG: action.loadingDaG }
        case LOADING_A_GESTIONAR:
            return { ...state, loadingDaG: action.loadingDaG }
        case DIVISIONES_GESTIONADAS:
            return { ...state, divisionesGestionadas: action.payload, loadingDg: action.loadingDg }
        case LOADING_GESTIONADAS:
            return { ...state, loadingDg: action.loadingDg }
        case ACT_A_GESTIONAR:
            return { ...state, actAgestionar: action.payload, loadingActAg: action.loadingActAg }
        case LOADING_ACT_A_GESTIONAR:
            return { ...state, loadingActAg: action.loadingActAg }
        case ACT_GESTIONADAS:
            return { ...state, actGestionadas: action.payload, loadingActG: action.loadingActG }
        case LOADING_ACT_GESTIONADAS:
            return { ...state, loadingActG: action.loadingActG }
        case PLANIFICACIONES_NO:
            return { ...state, planificacionesNo: action.payload, loadingPlanificacionesNo: action.loadingPlanificacionesNo }
        case LOADING_PLANIFICACIONESNO:
            return { ...state, loadingPlanificacionesNo: action.loadingPlanificacionesNo }
        case PLANIFICACIONES:
            return { ...state, planificaciones: action.payload, loadingPlanificaciones: action.loadingPlanificaciones }
        case LOADING_PLANIFICACIONES:
            return { ...state, loadingPlanificaciones: action.loadingPlanificaciones }
        case DIVISION:
            return { ...state, division: action.payload, loadingDivision: action.loadingDivision, getDivision: true }
        case LOADING_DIVISION:
            return { ...state, loadingDivision: action.loadingDivision, getDivision: false }
        case DIVISION_ERROR:
            return { ...state, loadingDivision: action.loadingDivision, getDivision: true }
        case FECHAS_X_DIVISION:
            return { ...state, fechas: action.payload, loadingFechas: action.loadingFechas, getFechas: true }
        case LOADING_FECHAS_X_DIVISION:
            return { ...state, loadingFechas: action.loadingFechas, getFechas: false }
        case FECHAS_X_DIVISION_ERROR:
            return { ...state, loadingFechas: action.loadingFechas, getFechas: true }
        case FECHAS_PARCIALES:
            return { ...state, fechasParciales: action.payload, loadingFechasParciales: action.loadingFechasParciales, getFechasParciales: true }
        case LOADING_FECHAS_PARCIALES:
            return { ...state, loadingFechasParciales: action.loadingFechasParciales, getFechasParciales: false }
        case FECHAS_PARCIALES_ERROR:
            return { ...state, loadingFechasParciales: action.loadingFechasParciales, getFechasParciales: true }
        case HORARIOS_X_ASIGNACION:
            return { ...state, horarios: action.payload, loadingHorarios: action.loadingHorarios, getHorarios: true }
        case LOADING_HORARIOS_X_ASIGNACION:
            return { ...state, loadingHorarios: action.loadingHorarios, getHorarios: false }
        case HORARIOS_X_ASIGNACION_ERROR:
            return { ...state, loadingHorarios: action.loadingHorarios, getHorarios: true }
        case FORMACION_DOCENTE:
            return { ...state, formacionDocente: action.payload, loadingFormacionDocente: action.loadingFormacionDocente, getFormacion: true }
        case LOADING_FORMACION_DOCENTE:
            return { ...state, loadingFormacionDocente: action.loadingFormacionDocente, getFormacion: false }
        case FORMACION_DOCENTE_ERROR:
            return { ...state, loadingFormacionDocente: action.loadingFormacionDocente, getFormacion: true }
        case TAREAS:
            return { ...state, tareas: action.payload, loadingTareas: action.loadingTareas, getTareas: true }
        case LOADING_TAREAS:
            return { ...state, loadingTareas: action.loadingTareas, getTareas: false }
        case TAREAS_ERROR:
            return { ...state, loadingTareas: action.loadingTareas, getTareas: true }
        case TEAM_TEACHING:
            return { ...state, teamTeaching: action.payload, loadingTeamTeaching: action.loadingTeamTeaching }
        case LOADING_TEAM_TEACHING:
            return { ...state, loadingTeamTeaching: action.loadingTeamTeaching }
        case EXPERIENCIA:
            return { ...state, experiencia: action.payload, loadingExperiencia: action.loadingExperiencia }
        case LOADING_EXPERIENCIA:
            return { ...state, loadingExperiencia: action.loadingExperiencia }
        case PROYECTO:
            return { ...state, proyecto: action.payload, loadingProyecto: action.loadingProyecto, getProyectoInvestigacion: true }
        case LOADING_PROYECTO:
            return { ...state, loadingProyecto: action.loadingProyecto, getProyectoInvestigacion: false }
        case PROYECTO_ERROR:
            return { ...state, loadingProyecto: action.loadingProyecto, getProyectoInvestigacion: true }
        case TRANSFERENCIA:
            return { ...state, transferencia: action.payload, loadingTransferencia: action.loadingTransferencia }
        case LOADING_TRANSFERENCIA:
            return { ...state, loadingTransferencia: action.loadingTransferencia }
        case PAT:
            return { ...state, pat: action.payload, loadingPat: action.loadingPat, getPat: true }
        case LOADING_PAT:
            return { ...state, loadingPat: action.loadingPat, getPat: false }
        case PAT_ERROR:
            return { ...state, loadingPat: action.loadingPat, getPat: true }
        case PIC:
            return { ...state, pic: action.payload, loadingPic: action.loadingPic, getPic: true }
        case LOADING_PIC:
            return { ...state, loadingPic: action.loadingPic, getPic: false }
        case PIC_ERROR:
            return { ...state, loadingPic: action.loadingPic, getPic: true }
        case LIMPIAR_ESTADOS:
            return {
                ...state,
                divisonesAgestionar: [],
                loadingDaG: false,
                divisionesGestionadas: [],
                loadingDg: false,
                actAgestionar: [],
                loadingActAg: false,
                actGestionadas: [],
                loadingActG: false,
                planificacionesNo: [],
                loadingPlanificacionesNo: false,
                planificaciones: [],
                loadingPlanificaciones: false,
                division: [],
                loadingDivision: false,
                getDivision: null,
                fechas: [],
                loadingFechas: false,
                getFechas: null,
                fechasParciales: [],
                loadingFechasParciales: false,
                getFechasParciales: null,
                horarios: [],
                loadingHorarios: false,
                getHorarios: null,
                formacionDocente: [],
                loadingFormacionDocente: false,
                getFormacion: null,
                loadingTareas: false,
                tareas: [],
                loadingActualizacion: false,
                getTareas: null,
                teamTeaching: [],
                loadingTeamTeaching: false,
                experiencia: [],
                loadingExperiencia: false,
                proyecto: [],
                loadingProyecto: false,
                getProyectoInvestigacion: null,
                transferencia: [],
                loadingTransferencia: false,
                pat: [],
                loadingPAT: false,
                getPat: null,
                pic: [],
                loadingPIC: false,
                getPic: null,
            }
        default:
            return { ...state }
    }
}

export const modificarPlanificacion = (objeto, id, token) => async (dispatch) => {
    const {  
        new_bibliografaampliatoria,
        new_bibliografabsica,
        new_categoriateorica,
        new_desarrollodeinvestigacion,
        new_didacticas1ernivel,
        new_didcticas2donivel,
        new_diferenciales,
        new_dimension,
        new_experiencia,
        new_extensionpatpic,
        new_fechadevencimiento,
        new_innovaciontecnologica,
        new_institutos,
        new_teamteachinginvitado,
        new_tipodedidcticas1ernivel,
        new_tipodeextension,
        new_tipodidacticas1ernivel,
        new_transferenciadeinvestigacion
    } = objeto;

    var tipodidacticas = new_tipodidacticas1ernivel.join(", ");
    var institutos = new_institutos.join(", ");
    var innovacion = new_innovaciontecnologica.join(", ");

    try {
        debugger
        const updatePlanificacion = () => new Promise(async (resolve, reject) => {
            await axios.put(`${UrlApi}api/hrfactors/planificacionunificada`,
                {
                    "new_planificacinunificadaid": id,
                    "new_fechadevencimiento": new_fechadevencimiento.format('YYYY-MM-DD'),
                    "new_transferenciadeinvestigacion": new_transferenciadeinvestigacion,
                    "new_desarrollodeinvestigacion": new_desarrollodeinvestigacion,
                    "new_extensionpatpic": new_extensionpatpic,
                    "new_tipodeextension": new_tipodeextension,
                    "new_teamteachinginvitado": new_teamteachinginvitado.value,
                    "new_experiencia": new_experiencia,
                    "new_didacticas1ernivel": new_didacticas1ernivel,
                    "new_tipodidacticas1ernivel": tipodidacticas,
                    "new_institutos": institutos,
                    "new_diferenciales": new_diferenciales,
                    "new_categoriateorica": new_categoriateorica,
                    "new_innovaciontecnologica": innovacion,
                    "new_dimension": new_dimension,
                    "new_bibliografabsica": new_bibliografabsica,
                    "new_bibliografaampliatoria": new_bibliografaampliatoria,
                    "new_didcticas2donivel": new_didcticas2donivel,
                    "new_tipodedidcticas1ernivel": new_tipodedidcticas1ernivel
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            ).then((response) => {
                dispatch({
                    type: MODIFICAR_PLANIFICACION_EXITO,
                    modificacionPlanificacion: 'EXITO',
                })
                resolve(response.data)
            })
                .catch(err => {

                    reject(err)
                    console.log(err)
                })
        })

        const response = await toast.promise(
            updatePlanificacion,
            {
                pending: 'Procesando...',
                success: 'Planificación modificada con éxito!',
                error: {
                    render({ data }) {
                        // console.log(data)
                        return `${data}`
                    }
                }
            },
            {
                theme: "dark",
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            }
        )
    } catch (error) {
        console.log(error)
        dispatch({
            type: MODIFICAR_PLANIFICACION_ERROR,
            modificacionPlanificacion: 'ERROR',
        })
    }
}

export const confirmarOrechazarAsignacion = (token, id, respuesta) => async (dispatch) => {
    dispatch({
        type: LOADING_ACTUALIZACION,
        loadingActualizacion: true,
    })

    try {

        const updateAsignacion = () => new Promise(async (resolve, reject) => {
            await axios.put(`${UrlApi}api/hrfactors/asignaciondocente`,
                {
                    "new_aceptaciondedivisionid": id,
                    "new_acepta": respuesta,
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            ).then((response) => {
                dispatch({
                    type: ACTUALIZACION_EXITO,
                    modificacion: 'EXITO',
                    loadingActualizacion: false
                })
                resolve(response.data)
            })
                .catch(err => {
                    debugger
                    reject(err)
                    console.log(err)
                })
        })

        const response = await toast.promise(
            updateAsignacion,
            {
                pending: 'Procesando...',
                success: 'Asignación modificada con éxito!',
                error: {
                    render({ data }) {
                        // console.log(data)
                        return `${data}`
                    }
                }
            },
            {
                theme: "dark",
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            }
        )
    } catch (error) {
        console.log(error)
        dispatch({
            type: ACTUALIZACION_ERROR,
            modificacion: 'ERROR',
            loadingActualizacion: false
        })
    }
}

export const divisionesAgestionar = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_A_GESTIONAR,
        loadingDaG: true
    })

    try {
        var entidad = "new_aceptaciondedivisions"
        var fetch =
            "<entity name='new_aceptaciondedivision'>" +
            "<attribute name='new_periodo' />" +
            "<attribute name='new_aceptaciondedivisionid' />" +
            "<attribute name='statuscode' />" +
            // "<attribute name='new_roldocente'/>" +
            "<order attribute='statuscode' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='statuscode' operator='eq' value='1' />" +
            // "<condition attribute='new_publicadoenportal' operator='eq' value='100000000' />" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docente' link-type='inner' alias='ac'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "<link-entity name='new_division' from='new_divisionid' to='new_division' link-type='inner' alias='division'>" +
            "<attribute name='new_name' />" +
            "<attribute name='new_divisionid' />" +
            "<attribute name='new_tipodedivision' />" +
            "<attribute name='statuscode' />" +
            "<attribute name='new_modalidaddictado' />" +
            "<attribute name='new_sede'/>" +
            "<attribute name='new_materia' />" +
            "<attribute name='new_areadisciplinar'/>" +
            "<attribute name='new_carreraid' />" +
            "<attribute name='new_codigomateria' />" +
            "<attribute name='new_carreraid' />" +
            "<attribute name='new_periodo' />" +
            "<attribute name='new_tipodedivision' />" +
            "<attribute name='new_modalidaddictado' />" +
            // "<attribute name='new_idcatedra' />" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: DIVISIONES_A_GESTIONAR,
            payload: response.data,
            loadingDaG: false
        })
    }
    catch (error) {
        dispatch({
            type: DIVISIONES_A_GESTIONAR_ERROR,
            loadingDaG: false
        })
    }
}

export const divisionesGestionadas = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_GESTIONADAS,
        loadingDg: true
    })

    try {
        var entidad = "new_aceptaciondedivisions"
        var fetch =
            "<entity name='new_aceptaciondedivision'>" +
            "<attribute name='new_periodo' />" +
            "<attribute name='new_aceptaciondedivisionid' />" +
            "<attribute name='statuscode' />" +
            "<attribute name='new_periodo' />" +
            // "<attribute name='new_roldocente'/>" +
            "<filter type='and'>" +
            "<condition attribute='statuscode' operator='in'>" +
            "<value>100000000</value>" +
            "<value>100000001</value>" +
            "<value>100000002</value>" +
            "</condition>" +
            // "<condition attribute='new_publicadoenportal' operator='eq' value='100000000' />" +
            "</filter>" +
            "<link-entity name='new_periodo' from='new_periodoid' to='new_periodo' link-type='inner' alias='ab'>" +
            "<attribute name='new_fechadesde' />" +
            "<order attribute='new_fechadesde' descending='false' />" +
            "</link-entity>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docente' link-type='inner' alias='ac'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "<link-entity name='new_division' from='new_divisionid' to='new_division' link-type='inner' alias='division'>" +
            "<attribute name='new_name' />" +
            "<attribute name='new_sede'/>" +
            "<attribute name='new_divisionid' />" +
            "<attribute name='new_tipodedivision' />" +
            "<attribute name='statuscode' />" +
            "<attribute name='new_modalidaddictado' />" +
            "<attribute name='new_materia' />" +
            "<attribute name='new_areadisciplinar'/>" +
            "<attribute name='new_carreraid' />" +
            "<attribute name='new_codigomateria' />" +
            // "<attribute name='new_idcatedra' />" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: DIVISIONES_GESTIONADAS,
            payload: response.data,
            loadingDg: false
        })
    }
    catch (error) {
        dispatch({
            type: DIVISIONES_GESTIONADAS_ERROR,
            loadingDg: false
        })
    }
}

export const actividadesAgestionar = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_ACT_A_GESTIONAR,
        loadingActAg: true
    })

    try {
        var entidad = "new_aceptaciondedivisions"
        var fetch =
            "<entity name='new_aceptaciondedivision'>" +
            "<attribute name='new_name' />" +
            "<attribute name='statuscode' />" +
            "<attribute name='new_aceptaciondedivisionid' />" +
            // "<attribute name='new_roldocente'/>" +
            "<order attribute='statuscode' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='statuscode' operator='eq' value='1' />" +
            // "<condition attribute='new_publicadoenportal' operator='eq' value='100000000' />" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docente' link-type='inner' alias='af'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "<link-entity name='new_asignaciondeactividades' from='new_asignaciondeactividadesid' to='new_asignacion' link-type='inner' alias='act'>" +
            "<attribute name='new_name' />" +
            "<attribute name='new_periodo' />" +
            "<attribute name='new_materia' />" +
            "<attribute name='new_codigomateria' />" +
            "<attribute name='new_carreraid' />" +
            "<attribute name='new_areadisciplinar' />" +
            "<attribute name='new_modalidad' />" +
            "<attribute name='new_asignaciondeactividadesid' />" +
            "<filter type='and'>" +
            "<filter type='or'>" +
            "<condition attribute='new_formatodeactividad' operator='eq' value='100000001' />" +
            "<condition attribute='new_actividadname' operator='like' value='%TEAM TEACHING%' />" +
            "</filter>" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: ACT_A_GESTIONAR,
            payload: response.data,
            loadingActAg: false
        })
    }
    catch (error) {
        dispatch({
            type: ACT_A_GESTIONAR_ERROR,
            loadingActAg: false
        })
    }
}

export const actividadesGestionadas = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_ACT_GESTIONADAS,
        loadingActG: true
    })

    try {
        var entidad = "new_aceptaciondedivisions"
        var fetch =
            "<entity name='new_aceptaciondedivision'>" +
            "<attribute name='new_name' />" +
            "<attribute name='statuscode' />" +
            "<attribute name='new_aceptaciondedivisionid' />" +
            // "<attribute name='new_roldocente'/>" +
            "<order attribute='statuscode' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='statuscode' operator='in'>" +
            "<value>100000003</value>" +
            "<value>100000000</value>" +
            "<value>100000001</value>" +
            "<value>100000002</value>" +
            "</condition>" +
            // "<condition attribute='new_publicadoenportal' operator='eq' value='100000000' />" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docente' link-type='inner' alias='af'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "<link-entity name='new_asignaciondeactividades' from='new_asignaciondeactividadesid' to='new_asignacion' link-type='inner' alias='act'>" +
            "<attribute name='new_name' />" +
            "<attribute name='new_periodo' />" +
            "<attribute name='new_materia' />" +
            "<attribute name='new_codigomateria' />" +
            "<attribute name='new_carreraid' />" +
            "<attribute name='new_areadisciplinar' />" +
            "<attribute name='new_modalidad' />" +
            "<attribute name='new_asignaciondeactividadesid' />" +
            "<filter type='and'>" +
            "<filter type='or'>" +
            "<condition attribute='new_formatodeactividad' operator='eq' value='100000001' />" +
            "<condition attribute='new_actividadname' operator='like' value='%TEAM TEACHING%' />" +
            "</filter>" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: ACT_GESTIONADAS,
            payload: response.data,
            loadingActG: false
        })
    }
    catch (error) {
        dispatch({
            type: ACT_GESTIONADAS_ERROR,
            loadingActG: false
        })
    }
}

export const planificacionesNoPresentadas = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_PLANIFICACIONESNO,
        loadingPlanificacionesNo: true
    })

    try {
        var entidad = "new_planificacinunificadas"
        var fetch =
            "<entity name='new_planificacinunificada'>" +
            "<attribute name='new_planificacinunificadaid' />" +
            "<attribute name='new_name' />" +
            "<attribute name='createdon' />" +
            "<attribute name='new_tipodeextension' />" +
            "<attribute name='new_teamteachinginvitado' />" +
            "<attribute name='new_teamteaching' />" +
            "<attribute name='new_matriz' />" +
            "<attribute name='new_materia' />" +
            "<attribute name='new_institutos' />" +
            "<attribute name='new_experiencia' />" +
            "<attribute name='new_docente' />" +
            "<attribute name='new_periodo' />" +
            "<attribute name='statuscode' />" +
            "<order attribute='new_name' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='statuscode' operator='eq' value='1' />" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docente' link-type='inner' alias='ac'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "<link-entity name='new_materia' from='new_materiaid' to='new_materia' visible='false' link-type='outer' alias='materia'>" +
            "<attribute name='new_codigomateria' />" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: PLANIFICACIONES_NO,
            payload: response.data,
            loadingPlanificacionesNo: false
        })
    }
    catch (error) {
        dispatch({
            type: PLANIFICACIONES_NO_ERROR,
            loadingPlanificacionesNo: false
        })
    }
}

export const planificacionesPresentadas = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_PLANIFICACIONES,
        loadingPlanificaciones: true
    })

    try {
        var entidad = "new_planificacinunificadas"
        var fetch =
            "<entity name='new_planificacinunificada'>" +
            "<attribute name='new_planificacinunificadaid' />" +
            "<attribute name='new_name' />" +
            "<attribute name='createdon' />" +
            "<attribute name='new_tipodeextension' />" +
            "<attribute name='new_teamteachinginvitado' />" +
            "<attribute name='new_teamteaching' />" +
            "<attribute name='new_matriz' />" +
            "<attribute name='new_materia' />" +
            "<attribute name='new_institutos' />" +
            "<attribute name='new_experiencia' />" +
            "<attribute name='new_docente' />" +
            "<attribute name='new_periodo' />" +
            "<attribute name='statuscode' />" +
            "<filter type='and'>" +
            "<condition attribute='statuscode' operator='eq' value='100000000' />" +
            "</filter>" +
            "<link-entity name='new_periodo' from='new_periodoid' to='new_periodo' link-type='inner' alias='ab'>" +
            "<attribute name='new_fechadesde' />" +
            "<order attribute='new_fechadesde' descending='true' />" +
            "</link-entity>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docente' link-type='inner' alias='ac'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: PLANIFICACIONES,
            payload: response.data,
            loadingPlanificaciones: false
        })
    }
    catch (error) {
        dispatch({
            type: PLANIFICACIONES_ERROR,
            loadingPlanificaciones: false
        })
    }
}

export const divisionXasignacion = (token, id, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_DIVISION,
        loadingDivision: true
    })

    try {
        var entidad = "new_aceptaciondedivisions"
        var fetch =
            "<entity name='new_aceptaciondedivision'>" +
            "<attribute name='new_motivoaceptacion'/>" +
            "<attribute name='new_docente'/>" +
            "<attribute name='new_acepta'/>" +
            "<attribute name='statuscode'/>" +
            "<attribute name='new_aceptaciondedivisionid'/>" +
            "<order attribute='new_docente' descending='false'/>" +
            "<filter type='and'>" +
            "<condition attribute='new_aceptaciondedivisionid' operator='eq'  uitype='new_aceptaciondedivision' value='" + id + "'/>" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docente' link-type='inner' alias='ac'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortal + "'/>" +
            "</filter>" +
            "</link-entity>" +
            "<link-entity name='new_division' from='new_divisionid' to='new_division' visible='false' link-type='inner' alias='division'>" +
            "<attribute name='new_divisionid'/>" +
            "<attribute name='new_tipodedivision'/>" +
            "<attribute name='new_sede'/>" +
            "<attribute name='new_periodo'/>" +
            "<attribute name='new_name'/>" +
            "<attribute name='new_modalidaddictado'/>" +
            "<attribute name='new_materia'/>" +
            "<attribute name='new_carreraid'/>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: DIVISION,
            payload: response.data,
            loadingDivision: false
        })
    }
    catch (error) {
        dispatch({
            type: DIVISION_ERROR,
            loadingDivision: false
        })
    }
}

export const horariosXasignacion = (token, id) => async (dispatch) => {
    dispatch({
        type: LOADING_HORARIOS_X_ASIGNACION,
        loadingHorarios: true
    })

    try {
        var entidad = "new_horariosdeladivisions"
        var fetch =
            "<entity name='new_horariosdeladivision'>" +
            "<attribute name='new_horainicio' />" +
            "<attribute name='new_horafin' />" +
            "<attribute name='new_dia' />" +
            "<attribute name='new_fecha'/>" +
            "<attribute name='new_horariosdeladivisionid' />" +
            "<attribute name='new_aula' />" +
            "<order attribute='new_horainicio' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='statecode' operator='eq' value='0' />" +
            "<condition attribute='new_division' operator='like' value='" + id + "' />" +
            "</filter>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: HORARIOS_X_ASIGNACION,
            payload: response.data,
            loadingHorarios: false
        })
    }
    catch (error) {
        dispatch({
            type: HORARIOS_X_ASIGNACION_ERROR,
            loadingHorarios: false
        })
    }
}

export const fechasParciales = (token, id) => async (dispatch) => {
    dispatch({
        type: LOADING_FECHAS_PARCIALES,
        loadingFechasParciales: true
    })

    try {
        var entidad = "new_eventospordivisions"
        var fetch =
            "<entity name='new_eventospordivision'>" +
            "<attribute name='new_eventospordivisionid' />" +
            "<attribute name='new_fechayhorainicio' />" +
            "<attribute name='new_clasedeparcial' />" +
            "<order attribute='new_fechayhorainicio' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='new_division' operator='like' value='" + id + "' />" +
            "</filter>" +
            "<link-entity name='new_division' from='new_divisionid' to='new_division' visible='false' link-type='outer' alias='division'>" +
            "<attribute name='new_materia' />" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: FECHAS_PARCIALES,
            payload: response.data,
            loadingFechasParciales: false
        })
    }
    catch (error) {
        dispatch({
            type: FECHAS_PARCIALES_ERROR,
            loadingFechasParciales: false
        })
    }
}

export const fechasXasignacion = (token, materia, periodo, modalidad) => async (dispatch) => {
    dispatch({
        type: LOADING_FECHAS_X_DIVISION,
        loadingFechas: true
    })

    try {
        var entidad = "new_exmenfinals"
        var fetch =
            "<entity name='new_exmenfinal'>" +
            "<attribute name='new_exmenfinalid' />" +
            "<attribute name='new_name' />" +
            "<attribute name='createdon' />" +
            "<attribute name='new_llamadoaexamen' />" +
            "<attribute name='new_fechayhora' />" +
            "<order attribute='new_name' descending='false' />" +
            "<link-entity name='new_eventodeplanificacindocente' from='new_eventodeplanificacindocenteid' to='new_eventodeplanificacindocenteasociado' link-type='inner' alias='Evento'>" +
            "<filter type='and'>" +
            "<condition attribute='new_materia' operator='eq' uitype='new_materia' value='" + materia + "' />" +
            "<condition attribute='new_periodo' operator='eq' uitype='new_periodo' value='" + periodo + "' />" +
            "<condition attribute='new_modalidad' operator='eq' uitype='new_modalidaddedictado' value='" + modalidad + "' />" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: FECHAS_X_DIVISION,
            payload: response.data,
            loadingFechas: false
        })
    }
    catch (error) {
        dispatch({
            type: FECHAS_X_DIVISION_ERROR,
            loadingFechas: false
        })
    }
}

export const formacionDocenteXasignacion = (token, id, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_FORMACION_DOCENTE,
        loadingFormacionDocente: true
    })

    try {
        var entidad = "new_cursos"
        var fetch =
            "<entity name='new_curso'>" +
            "<attribute name='new_cursoid' />" +
            "<attribute name='new_name' />" +
            "<attribute name='new_grado' />" +
            "<attribute name='new_subdisciplina' />" +
            "<attribute name='cr879_tipodeexperienciadeaprendizaje' />" +
            "<attribute name='new_tipodeformacion' />" +
            "<order attribute='new_name' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='new_tipodeformacion' operator='in'>" +
            "<value>100000000</value>" +
            "<value>100000001</value>" +
            "</condition>" +
            "</filter>" +
            "<link-entity name='new_formacindocente' from='new_curso' to='new_cursoid' link-type='inner' alias='ak'>" +
            "<attribute name='new_formacindocenteid' />" +
            "<attribute name='new_asignacin' />" +
            "<attribute name='new_curso' />" +
            "<attribute name='statuscode'/>" +
            "<filter type='and'>" +
            "<condition attribute='new_asignacin' operator='eq' value='" + id + "'/>" +
            "<condition attribute='statuscode' operator='in'>" +
            "<value>100000000</value>" +
            "<value>100000004</value>" +
            "<value>100000001</value>" +
            "</condition>" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docente' link-type='inner' alias='al'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "<link-entity name='new_beca' from='new_formacindocente' to='new_formacindocenteid' link-type='outer' alias='am'>" +
            "<attribute name='new_becaid' />" +
            "<filter type='and'>" +
            "<condition attribute='new_tipodebeca' operator='in'>" +
            "<value>100000000</value>" +
            "<value>100000001</value>" +
            "</condition>" +
            "</filter>" +
            "</link-entity>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: FORMACION_DOCENTE,
            payload: response.data,
            loadingFormacionDocente: false
        })
    }
    catch (error) {
        dispatch({
            type: FORMACION_DOCENTE_ERROR,
            loadingFormacionDocente: false
        })
    }
}

export const tareasXasignacion = (token, id, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_TAREAS,
        loadingTareas: true
    })

    try {
        var entidad = "tasks"
        var fetch =
            "<entity name='task'>" +
            "<attribute name='subject' />" +
            "<attribute name='new_materia' />" +
            "<attribute name='scheduledstart' />" +
            "<attribute name='scheduledend' />" +
            "<attribute name='activityid' />" +
            "<order attribute='subject' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='new_division' operator='like' value='" + id + "' />" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='regardingobjectid' link-type='inner' alias='aa'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: TAREAS,
            payload: response.data,
            loadingTareas: false
        })
    }
    catch (error) {
        dispatch({
            type: TAREAS_ERROR,
            loadingTareas: false
        })
    }
}

export const teamTeaching = (token, id, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_TEAM_TEACHING,
        loadingTeamTeaching: true
    })

    try {
        var entidad = "new_teamteachings"
        var fetch =
            "<entity name='new_teamteaching'>" +
            "<attribute name='new_teamteachingid' />" +
            "<attribute name='new_name' />" +
            "<attribute name='createdon' />" +
            "<attribute name='new_matriz' />" +
            "<attribute name='new_materia' />" +
            "<attribute name='new_docenteacargo' />" +
            "<attribute name='new_division' />" +
            "<attribute name='new_teamteachinginvitado' />" +
            "<attribute name='new_cantidaddepersonasqueasistenalaactividad' />" +
            "<attribute name='new_fechadelteamteaching' />" +
            "<order attribute='new_name' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='new_division' operator='eq' value='" + id + "' />" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docenteacargo' link-type='inner' alias='aa'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: TEAM_TEACHING,
            payload: response.data,
            loadingTeamTeaching: false
        })
    }
    catch (error) {
        dispatch({
            type: TEAM_TEACHING_ERROR,
            loadingTeamTeaching: false
        })
    }
}

export const experiencia = (token, id, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_EXPERIENCIA,
        loadingExperiencia: true
    })

    try {
        var entidad = "new_experiencias"
        var fetch =
            "<entity name='new_experiencia'>" +
            "<attribute name='new_experienciaid' />" +
            "<attribute name='new_name' />" +
            "<attribute name='createdon' />" +
            "<attribute name='new_tipodeexperiencia' />" +
            "<attribute name='new_qpersonasqueasistenalaactividad' />" +
            "<attribute name='new_matriz' />" +
            "<attribute name='new_materia' />" +
            "<attribute name='new_docenteacargo' />" +
            "<attribute name='new_fechaactividad' />" +
            "<attribute name='new_division' />" +
            "<order attribute='new_name' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='new_division' operator='eq' value='" + id + "' />" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docenteacargo' link-type='inner' alias='ab'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";
        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: EXPERIENCIA,
            payload: response.data,
            loadingExperiencia: false
        })
    }
    catch (error) {
        dispatch({
            type: EXPERIENCIA_ERROR,
            loadingExperiencia: false
        })
    }
}

export const proyectoInvestigacion = (token, id, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_PROYECTO,
        loadingProyecto: true
    })

    try {
        var entidad = "new_proyectosdeinvestigacins"
        var fetch =
            "<entity name='new_proyectosdeinvestigacin'>" +
            "<attribute name='new_proyectosdeinvestigacinid' />" +
            "<attribute name='new_name' />" +
            "<attribute name='createdon' />" +
            "<attribute name='statuscode' />" +
            "<attribute name='new_metaria' />" +
            "<attribute name='new_matriz' />" +
            "<attribute name='new_fechadeinicio' />" +
            "<attribute name='new_fechadefinalizacin' />" +
            "<attribute name='new_division' />" +
            "<order attribute='new_name' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='new_division' operator='eq' value='" + id + "' />" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='aa'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";
        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: PROYECTO,
            payload: response.data,
            loadingProyecto: false
        })
    }
    catch (error) {
        dispatch({
            type: PROYECTO_ERROR,
            loadingProyecto: false
        })
    }
}

export const transferenciaInvestigacion = (token, id, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_TRANSFERENCIA,
        loadingTransferencia: true
    })

    try {
        var entidad = "new_transferenciadeinvestigacions"
        var fetch =
            "<entity name='new_transferenciadeinvestigacion'>" +
            "<attribute name='new_transferenciadeinvestigacionid' />" +
            "<attribute name='new_name' />" +
            "<attribute name='createdon' />" +
            "<attribute name='new_tieneexperienciaeninvestigacion' />" +
            "<attribute name='new_modalidad' />" +
            "<attribute name='new_matriz' />" +
            "<attribute name='new_materia' />" +
            "<attribute name='new_fechadetransferencia' />" +
            "<attribute name='new_divisin' />" +
            "<order attribute='new_name' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='new_divisin' operator='eq' value='" + id + "' />" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docentetransfiereinvestigacion' link-type='inner' alias='ab'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: TRANSFERENCIA,
            payload: response.data,
            loadingTransferencia: false
        })
    }
    catch (error) {
        dispatch({
            type: TRANSFERENCIA_ERROR,
            loadingTransferencia: false
        })
    }
}

export const proyectoAcademicoTransversal = (token, id, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_PAT,
        loadingPat: true
    })

    try {
        var entidad = "new_proyectoacadmicotransversalpats"
        var fetch =
            "<entity name='new_proyectoacadmicotransversalpat'>" +
            "<attribute name='new_proyectoacadmicotransversalpatid' />" +
            "<attribute name='new_name' />" +
            "<attribute name='createdon' />" +
            "<attribute name='new_ttulodelpat' />" +
            "<attribute name='new_sede' />" +
            "<attribute name='new_modalidad' />" +
            "<attribute name='new_matriz' />" +
            "<attribute name='new_materia' />" +
            "<attribute name='new_divisin' />" +
            "<order attribute='new_name' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='new_divisin' operator='eq' value='" + id + "' />" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docenteacargo' link-type='inner' alias='ac'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: PAT,
            payload: response.data,
            loadingPat: false
        })
    }
    catch (error) {
        dispatch({
            type: PAT_ERROR,
            loadingPat: false
        })
    }
}

export const proyectoIntervencionComunitaria = (token, id, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_PIC,
        loadingPic: true
    })

    try {
        var entidad = "new_proyectosdeintervencincomunitariapics"
        var fetch =
            "<entity name='new_proyectosdeintervencincomunitariapic'>" +
            "<attribute name='new_proyectosdeintervencincomunitariapicid' />" +
            "<attribute name='new_name' />" +
            "<attribute name='createdon' />" +
            "<attribute name='new_matriz' />" +
            "<attribute name='new_materia' />" +
            "<attribute name='new_division' />" +
            "<order attribute='new_name' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='new_division' operator='eq' value='" + id + "' />" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docenteacargo' link-type='inner' alias='ae'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";
        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: PIC,
            payload: response.data,
            loadingPic: false
        })
    }
    catch (error) {
        dispatch({
            type: PIC_ERROR,
            loadingPic: false
        })
    }
}

export const limpiarTodosLosEstados = () => {
    return {
        type: 'LIMPIAR_ESTADOS',
    };
};